import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-dark/95 backdrop-blur-lg shadow-lg border-b border-white/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/8a970083-971d-4b19-9687-f1352617b959.png" 
              alt="Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-xl font-bold text-white">SaaS Solutions</span>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-300 hover:text-primary transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('use-cases')}
              className="text-gray-300 hover:text-primary transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              Use Cases
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="text-gray-300 hover:text-primary transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              Projekte
            </button>
            <button
              onClick={() => scrollToSection('technology')}
              className="text-gray-300 hover:text-primary transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              Technologie
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-300 hover:text-primary transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              Kontakt
            </button>
            <a
              href="/demo"
              className="bg-gradient-to-r from-primary to-primary-light text-white px-6 py-2.5 rounded-lg font-medium hover:shadow-lg hover:shadow-primary/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Demo ansehen
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
